module.exports = __webpack_public_path__ + "img/sdc2018-site3.e13cb9d0.png";